module.exports = __webpack_public_path__ + "img/主题.660c7efc.png";